import { setCookie, getCookie } from "../../utilities/cookies";
import { useEffect } from "react";

const Login = () => {

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encodedUser = params.get('user');
    const refreshToken = params.get('refreshToken');

    console.log(params,"params");
    console.log(encodedUser,"encodedUser");
    console.log(refreshToken,"refreshToken");
    
    if (!encodedUser) return;

    try {
      const decoded = atob(encodedUser);
      const userObj = JSON.parse(decoded);

      setCookie("user", userObj);
      const user =  getCookie("user");
      const targetUrl = new URL(user.sourceUrl);
      targetUrl.searchParams.set('userId', user.user._id);
      if (user.refreshToken) {
        targetUrl.searchParams.set('refreshToken',  user.refreshToken);
      }

      window.location.href = targetUrl.toString();
    } catch (e) {
      console.error('Failed to decode or set user cookie', e);
    }
  }, []);

  return <div>Saving User data!</div>;
};

export default Login;
